const useUserAvatar = (
  user: {
    image?: string | null;
    email?: string;
    first_name?: string;
    last_name?: string;
    full_name?: string;
  },
  isTelegramUser?: boolean
) => {
  const removeNonAlphabetChars = (value?: string) =>
    (value || "").replace(/[^a-z ]/gi, "").replace(" ", "");
  const firstName = removeNonAlphabetChars(user.first_name);
  const lastName = removeNonAlphabetChars(user.last_name);
  const fullName = removeNonAlphabetChars(user.full_name);
  const email = removeNonAlphabetChars(user.email);

  const telegramUserFallbackLetters =
    (firstName?.charAt(0) || "") + (lastName?.charAt(0) || "");

  const fallbackLetters = (email || fullName).slice(0, 2).toLocaleUpperCase();

  return {
    imageText: isTelegramUser ? telegramUserFallbackLetters : fallbackLetters,
  };
};

export default useUserAvatar;
